import { HttpClientTypes } from "@rshbintech.dboul/http-client";
import type { MonolithApiTypes } from "@rshbintech.dboul/http-monolith";

export async function asyncPrintPdf(
  request: Promise<
    HttpClientTypes.HttpResponse<Blob, MonolithApiTypes.ErrorResponse>
  >,
  isOpenInNewTab = false,
  downloadText = ""
) {
  try {
    const response = await request;
    let blob = response.bodyUsed ? response.data : await response.blob();
    const linkElement = document.createElement("a");

    if (isOpenInNewTab) {
      blob = new Blob([blob], { type: "application/pdf" });
      linkElement.target = "_blank";
    } else {
      linkElement.download = downloadText;
    }

    linkElement.href = window.URL.createObjectURL(blob);
    document.body.appendChild(linkElement);
    linkElement.click();
    linkElement.remove();
  } catch (e) {
    throw e;
  }
}
